export default __webpack_public_path__ + "static/media/toxto.f7481109.png";